const middleware = {}

middleware['auth'] = require('../middleware/auth.ts')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['authOrIdentified'] = require('../middleware/authOrIdentified.ts')
middleware['authOrIdentified'] = middleware['authOrIdentified'].default || middleware['authOrIdentified']

middleware['guest'] = require('../middleware/guest.ts')
middleware['guest'] = middleware['guest'].default || middleware['guest']

middleware['routing'] = require('../middleware/routing.ts')
middleware['routing'] = middleware['routing'].default || middleware['routing']

middleware['searchPageGuard'] = require('../middleware/searchPageGuard.ts')
middleware['searchPageGuard'] = middleware['searchPageGuard'].default || middleware['searchPageGuard']

export default middleware
